import { Component } from '@verndale/core';
import { ConditionalDisplay } from '../helpers/global';

class Community extends Component {
  setupDefaults() {
    this.dom = {
      community: this.el.querySelectorAll('.v-section-community__li'),
      iframe: this.el.querySelector('.v-section-community__map iframe') as HTMLIFrameElement
    };

    if (ConditionalDisplay(this.el.id)) {
      this.el.style.display = 'none';
    }
    this.replaceIframe();
    this.removeEmptyCommunity();

    const options = {
      root: document.querySelector('#scrollArea'),
      rootMargin: '0px',
      threshold: 1.0
    };

    const observer = new IntersectionObserver(this.scrolledIntoView.bind(this), options);
    observer.observe(this.el);
  }

  scrolledIntoView(entries: IntersectionObserverEntry[], observer: IntersectionObserver) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.replaceIframe();
        observer.unobserve(entry.target);
      }
    });
  }

  replaceIframe() {
    const name = document.body.dataset.name || '';
    const state = document.body.dataset.state || '';

    if (this.dom.iframe) {
      const map = this.dom.iframe as HTMLIFrameElement;
      map.src = '';
      window.requestAnimationFrame(() => {
        const src =
          'https://www.google.com/maps/embed/v1/search?key=AIzaSyCE5I18JBlnz2x5x8FSnGX1Tt0rov72ZV0&q=community+centers+and+religious+centers+in+{city}+{state}&zoom=12';
        map.src = src.replace('{city}', name).replace('{state}', state);
      });
    }
  }

  removeEmptyCommunity() {
    (this.dom.community as NodeListOf<HTMLElement>)?.forEach(community => {
      if (!community.querySelector('.v-section-community__grade')?.getAttribute('alt')) {
        community.style.display = 'none';
      }
    });
  }
}

export default Community;
